"use client"

import { MonthSelector } from "./MonthSelector"

/**
 * Barra extensa con selector de mes.
 * Reemplaza el "MonthSelector" suelto y aprovecha el espacio entre los Tabs y el contenido.
 *
 * @param {Date} selectedMonth
 * @param {(d: Date) => void} onMonthChange
 * @param {React.ReactNode} children - contenido extra a la derecha del selector (opcional)
 */
export function PeriodBar({ selectedMonth, onMonthChange, children }) {
  return (
    <div className="rounded-2xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-900 shadow-sm overflow-hidden">
      <div className="relative">
        {/* Decorative top bar */}
        <div className="pointer-events-none absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-rose-500 via-pink-500 to-rose-500" />

        <div className="px-4 py-3 flex items-center justify-between flex-wrap gap-3">
          {/* Lado izquierdo: selector */}
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline-flex text-[10px] uppercase tracking-widest font-bold text-slate-400 dark:text-slate-500">
              Período activo
            </span>
            <MonthSelector value={selectedMonth} onChange={onMonthChange} />
          </div>

          {/* Lado derecho: contenido extra (a definir) */}
          {children && (
            <div className="flex items-center gap-2 flex-wrap">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
